import { Badge, Button, Tooltip } from '@chronosphereio/chrono-ui';
import { useAIEdit } from './ai-edit-context';
import { useEditWithAIButtonSx } from './edit-with-ai-button-sx';

/**
 * "Edit with AI" button that opens the AI edit panel. Typically rendered
 * via QueryEditor.Input's `endAdornment` prop or in a toolbar.
 *
 * Self-gating: returns null when the AI edit panel is already open.
 */
export function AIEditButton() {
  const { isOpen, open } = useAIEdit();
  const sx = useEditWithAIButtonSx();

  if (isOpen) return null;

  return (
    <Tooltip
      placement="left"
      Content={<Badge variant="new" size="small" label="Early access" sx={{ whiteSpace: 'nowrap' }} />}
      componentsProps={{
        tooltip: { sx: { backgroundColor: 'transparent', boxShadow: 'none', p: 0 } },
        popper: { modifiers: [{ name: 'offset', options: { offset: [0, -6] } }] },
      }}
    >
      <Button size="small" variant="secondary" onClick={open} sx={sx}>
        Edit with AI
      </Button>
    </Tooltip>
  );
}
